(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-videos"] && !Shopify.designMode) return;
  try {
    
class CustomerVideos extends HTMLElement {
  connectedCallback() {
    this.rail = this.querySelector('[data-cv-rail]');
    this.prevBtn = this.querySelector('[data-cv-prev]');
    this.nextBtn = this.querySelector('[data-cv-next]');
    this.dots = Array.from(this.querySelectorAll('[data-cv-dot]'));
    this.lightbox = this.querySelector('[data-cv-lightbox]');
    this.video = this.querySelector('[data-cv-video]');
    this.iframe = this.querySelector('[data-cv-iframe]');
    this.lastFocused = null;
    this._ticking = false;

    if (!this.rail) return;

    this.rail.addEventListener('scroll', () => {
      if (this._ticking) return;
      this._ticking = true;
      requestAnimationFrame(() => {
        this.updateArrows();
        this.updateDots();
        this._ticking = false;
      });
    });
    window.addEventListener('resize', () => {
      this.updateArrows();
      this.updateDots();
    });

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollByStep(-1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollByStep(1));

    this.querySelectorAll('[data-cv-open]').forEach((card) => {
      card.addEventListener('click', () => this.open(card));
    });

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this.rail.scrollTo({ left: this.step() * i, behavior: 'smooth' });
      });
    });

    if (this.lightbox) {
      // Close on the X button or any click outside the video/embed stage.
      this.lightbox.addEventListener('click', (e) => {
        if (e.target.closest('[data-cv-close]') || !e.target.closest('.cv__lightbox-stage')) {
          this.close();
        }
      });
      this.lightbox.addEventListener('keydown', (e) => this.onKeydown(e));
    }

    this.updateArrows();
    this.updateDots();
  }

  step() {
    const card = this.rail.querySelector('.cv__card');
    if (!card) return 0;
    const styles = getComputedStyle(this.rail);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return card.offsetWidth + gap;
  }

  scrollByStep(dir) {
    this.rail.scrollBy({ left: this.step() * dir, behavior: 'smooth' });
  }

  updateArrows() {
    if (!this.prevBtn || !this.nextBtn) return;
    const max = this.rail.scrollWidth - this.rail.clientWidth;
    this.prevBtn.disabled = this.rail.scrollLeft <= 2;
    this.nextBtn.disabled = this.rail.scrollLeft >= max - 2;
  }

  updateDots() {
    if (!this.dots.length) return;
    const step = this.step();
    const idx = step ? Math.round(this.rail.scrollLeft / step) : 0;
    this.dots.forEach((d, i) => d.classList.toggle('cv__dot--active', i === idx));
  }

  embedUrl(url) {
    let m = url.match(/tiktok\.com\/(?:.*\/video|embed\/v2|embed)\/(\d+)/);
    if (m) return 'https://www.tiktok.com/embed/v2/' + m[1];
    m = url.match(/instagram\.com\/(?:p|reel|reels|tv)\/([\w-]+)/);
    if (m) return 'https://www.instagram.com/p/' + m[1] + '/embed';
    return null;
  }

  open(card) {
    if (!this.lightbox || !this.video) return;
    const src = card.getAttribute('data-cv-src');
    const poster = card.getAttribute('data-cv-poster');
    if (!src) return;
    this.lastFocused = document.activeElement;

    const embed = this.embedUrl(src);
    if (embed && this.iframe) {
      this.iframe.src = embed;
      this.iframe.hidden = false;
      this.video.hidden = true;
      this.lightbox.classList.add('cv__lightbox--embed');
    } else {
      if (poster) this.video.setAttribute('poster', poster);
      this.video.src = src;
      this.video.muted = false;
      this.video.hidden = false;
      if (this.iframe) this.iframe.hidden = true;
      this.lightbox.classList.remove('cv__lightbox--embed');
    }

    this.lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    const closeBtn = this.lightbox.querySelector('.cv__lightbox-close');
    if (closeBtn) closeBtn.focus();

    if (!embed) {
      const playPromise = this.video.play();
      if (playPromise && playPromise.catch) playPromise.catch(() => {});
    }
  }

  close() {
    if (!this.lightbox || !this.video) return;
    this.video.pause();
    this.video.removeAttribute('src');
    this.video.removeAttribute('poster');
    this.video.load();
    if (this.iframe) this.iframe.removeAttribute('src');
    this.lightbox.hidden = true;
    this.lightbox.classList.remove('cv__lightbox--embed');
    document.body.style.overflow = '';
    if (this.lastFocused && this.lastFocused.focus) this.lastFocused.focus();
  }

  onKeydown(e) {
    if (e.key === 'Escape') {
      this.close();
      return;
    }
    if (e.key === 'Tab') {
      const focusable = this.lightbox.querySelectorAll('button, video, iframe');
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }
}

if (!customElements.get('customer-videos')) {
  customElements.define('customer-videos', CustomerVideos);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
